import { URGENCY_LEVEL_ICONS } from '../../../utils/dataStyles';

/**
 * Get the Font Awesome class for an urgency level.
 * Falls back to ROUTINE when level is missing or unmapped.
 */
export function getUrgencyIcon(urgencyLevel?: string | null): string {
  if (urgencyLevel && URGENCY_LEVEL_ICONS[urgencyLevel]) {
    return URGENCY_LEVEL_ICONS[urgencyLevel];
  }
  return URGENCY_LEVEL_ICONS.ROUTINE;
}
